module.exports = __webpack_public_path__ + "img/ev_icon.0dcf0957.svg";